import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className="ri-emotion-sad-line text-4xl" />
      </span>
      <h1 className="mt-6 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">页面走丢了</h1>
      <p className="mt-3 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移除（{location.pathname}）。回到首页，继续发现好看的影视内容吧。
      </p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/news"
          className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          浏览资讯
        </Link>
      </div>
    </div>
  );
}